export default __webpack_public_path__ + "static/media/case-study-7-t45-gun.ad3b8b9e.mp4";